export default {
  data() {
    return {
      formModel: {}, // 提交对象
      formRule: {}, // 验证规则
      columnType: this.$utils.columnType,
      tempFromName: 'form_' + new Date().getMilliseconds(),
      fileType: ['image', 'video', 'voice', 'file'],
      formType: {
        insert: 'insert', // 编辑状态
        update: 'update', // 编辑状态
        search: 'search', // 搜索
        other: 'other'
      }
    }
  },
  methods: {
    // 多选级联change事件
    valueChangeMultiple(val, column) {
      this.newGoodsClassIdList = []
      if (!this.cascaderProp.checkStrictly) {
        // 二维数组合并去重
        let arr = []
        val.forEach(v => {
          if (typeof v === 'object') {
            arr = [...arr, ...v]
          }
        })
        const set = new Set(arr);
        this.newGoodsClassIdList = [...set]
        // this.formModel[column.prop.replace('Cascader', '')] = [...set]
      }
      if (column.hidden || column.disabled) return;
      column.change && column.change(this.formModel);
    },
    // visibleChange(visible, refName, column) {
    //     let that = this
    //     if (visible) {
    //         const ref = this.$refs[refName][0];
    //         let popper = ref.$refs.popper;
    //         if (popper.$el) popper = popper.$el;
    //         if (!Array.from(popper.children).some(v => v.className === 'el-cascader-menu__list')) {
    //             const el = document.createElement('ul');
    //             el.className = 'el-cascader-menu__list';
    //             el.style = 'border-top: solid 1px #E4E7ED; padding:0; color: #606266;';
    //             el.innerHTML = `<div style="display: flex;align-items: center;padding:5px 10px">
    //           <input type="checkbox" checked id="checkId"/><span>全选</span></div>`
    //             popper.appendChild(el);
    //             const inputEl = document.getElementById('checkId')
    //             inputEl.onclick = function() {
    //                 that.formModel[column.prop] = []
    //                 if (this.checked) {
    //                     that.cascaderProp.checkStrictly = false
    //                 } else {
    //                     that.cascaderProp.checkStrictly = true
    //                 }
    //                 that.getSelectData(column)
    //                     // that.formModel[column.prop] = that.selectAllList
    //                 that.$forceUpdate()
    //             };
    //         }
    //     }
    // },
    setOptionsData(formOptions) {
      let keys = Object.keys(this.formModel);
      let optionsLength = formOptions.columns.length;
      for (let index = 0; index < optionsLength; index++) {
        optionsLength = formOptions.columns.length;
        let column = formOptions.columns[index];
        this.$set(this.formRule, column.prop, column.rule || []);
        if (formOptions.formType === this.formType.insert || keys.length == 0) {
          if (
            (column.type === this.columnType.select &&
              column.multiple == true) ||
            column.type == this.columnType.checkbox
          ) {
            this.$set(this.formModel, column.prop, []);
          } else if (column.type === this.columnType.switch) {
            this.$set(this.formModel, column.prop, false);
          } else if (column.type === this.columnType.inputNumber) {
            this.$set(this.formModel, column.prop, undefined);
          } else {
            this.$set(this.formModel, column.prop, '');
          }
        }
        // 设置默认值
        if (
          column.defaultValue != undefined &&
          formOptions.formType === this.formType.insert
        ) {
          this.formModel[column.prop] = column.defaultValue;
        }
        // this.setCascaderColumn(column,formOptions)
        // 设置单选按钮
        this.setRadioColumn(column, formOptions, index);
        // 设置多选按钮
        this.setCheckboxColumn(column, formOptions, index);

        // 重复密码校验
        if (column.type === this.columnType.repassword) {
          this.formRule[column.prop] = [{
            validator: (rule, value, callback) => {
              if (this.formModel[column.passwordProp] === value) {
                callback();
              } else {
                callback(new Error('两次密码输入不一致！'));
              }
            },
            trigger: 'blur'
          }];
        }
        if (column.url && (column.type === this.columnType.select || column.type === this.columnType.cascader || column.type === this.columnType.cascaderMultiple) &&
          (!column.data || column.data.length == 0)
        ) {
          this.getSelectData(column);
        }
        // 设置默认选项
        if (
          column.defaultIndex != undefined &&
          column.type === this.columnType.select &&
          column.data.length > 0
        ) {
          this.formModel[column.prop] = column.data[column.defaultIndex].value;
        }
        if (
          column.multiple &&
          column.type === this.columnType.select &&
          formOptions.formType !== this.formType.insert &&
          !this.formModel[column.prop]
        ) {
          let key = column.prop + 'List';
          let selectData = this.formModel[key] || [];
          let selectItem = [];
          selectData &&
          selectData.map((sitem) => {
            selectItem.push(sitem.id);
            sitem.label = sitem.name;
            sitem.value = sitem.id;
          });
          this.$set(this.formModel, column.prop, selectItem);
        }
        if (
          formOptions.formType !== this.formType.insert &&
          this.formModel[column.prop]
        ) {
          if ((!column.hidden && !column.disabled) || column.hiddenType == this.columnType.radio ||
            column.hiddenType == this.columnType.checkbox
          ) {
            column.change && column.change(this.formModel);
          }
        }
      }
      this.$store.commit(this.$utils.storeKeys.CURRENTFORM, this.formModel);
      this.formOptions = formOptions;

      // 所有数据准备就绪，且页面已更改
      this.$nextTick(() => {
        this.formOptions.callback && this.formOptions.callback(this.formModel);
        this.setChildValue();
      });
    },
    // 设置级联多选 全选
    //   setCascaderColumn(column, formOptions,index){
    //     if (column.type === this.columnType.radio){
    //       if(column.prop.indexOf('Cascader')==-1 && formOptions.columns.filter((item) => item.prop == column.prop + "Cascader").length == 0){
    //         let cloneColumn = this.$utils.deepClone(column);
    //         cloneColumn.prop = cloneColumn.prop + "Cascader";
    //         formOptions.columns.splice(index, 0, cloneColumn);
    //         this.$set(this.formModel, cloneColumn.prop, "");
    //         if(column.url){
    //           this.getSelectData(cloneColumn);
    //         }
    //       }
    //     }
    //   },
    setRadioColumn(column, formOptions, index) {
      if (column.type === this.columnType.radio) {
        if (column.prop.indexOf('Radio') == -1 &&
          formOptions.columns.filter((item) => item.prop == column.prop + 'Radio').length == 0) {
          let cloneColumn = this.$utils.deepClone(column);
          cloneColumn.prop = cloneColumn.prop + 'Radio';
          formOptions.columns.splice(index, 0, cloneColumn);
          column.hidden = true;
          column.hiddenType = column.type;
          column.type = 'input';
          this.$set(this.formModel, cloneColumn.prop, '');
          if (column.url) {
            this.getSelectData(cloneColumn);
          } else {
            this.setRadioValue(cloneColumn);
          }
          ;
        } else {
          this.setRadioValue(column);
        }
      }
    },
    setCheckboxColumn(column, formOptions, index) {
      if (column.type === this.columnType.checkbox) {
        if (column.prop.indexOf('Checkbox') == -1 &&
          formOptions.columns.filter((item) => item.prop == column.prop + 'Checkbox').length == 0) {
          let cloneColumn = this.$utils.deepClone(column);
          cloneColumn.prop = cloneColumn.prop + 'Checkbox';
          formOptions.columns.splice(index - 1, 0, cloneColumn);
          column.hiddenType = column.type;
          column.type = 'input';
          column.hidden = true;
          this.$set(this.formModel, cloneColumn.prop, []);
          if (column.url) {
            this.getSelectData(cloneColumn);
          } else {
            this.setCheckBoxValue(cloneColumn);
          }
        } else {
          this.setCheckBoxValue(column);
        }
      }
    },
    // 为子组件赋值
    setChildValue() {
      this.formOptions && this.formOptions.columns.map(column => {
        switch (column.type) {
          case this.columnType.attributeEditor:
          case this.columnType.code:
          case this.columnType.casaderSelect:
          case this.columnType.dateTimeRange:
          case this.columnType.checkList:
          case this.$utils.fileType.video.value:
          case this.$utils.fileType.voice.value:
          case this.$utils.fileType.image.value:
          case this.$utils.fileType.file.value:
          case this.columnType.mchntNo:
            this.$refs[column.prop] && this.$refs[column.prop].length > 0 && this.$refs[column.prop][0].setValue();
            break;
        }
      });
    },
    // 删除空子级
    deleteEmptyChild(arr = []) {
      arr.map(v => {
        if (v.children && v.children.length > 0) {
          return this.deleteEmptyChild(v.children)
        }
        delete v.children
      })
    },
    // 获取各种下拉菜单信息
    getSelectData(column, param, url) {
      let params = Object.assign(column.param || {}, param || {});
      // 缓存读取
      column.data = this.$utils.getDataByKey(column.url);
      if (!column.data || column.data.length == 0) {
        this.$axios.fetchPost((column.url || url) + '/list', params || {}).then(data => {
          column.url = url || column.url;
          if (data.code == 200) {
            if (column.multiple && this.formModel[column.prop + 'List']) {
              let selectList = this.formModel[column.prop + 'List'];
              data.data.map(item => {
                let uniqueValue = item[column.uniqueKey] || item.id || item.value
                let idx = selectList.map(selItem => {
                  return selItem[column.uniqueKey] || selItem.id || selItem.value
                })
                  .indexOf(uniqueValue);
                if (idx > -1) {
                  selectList.splice(idx, 1)
                }
              })
              this.$set(column, 'data', [...data.data, ...selectList]);
            } else if (column.type === this.columnType.cascaderMultiple) { // 多选级联
              // data.data.unshift({label:'全选',value:''})
              this.deleteEmptyChild(data.data)
              this.$set(column, 'data', data.data);
            } else if (column.isHasAll || column.isHasAllShop || column.hasAllNull) { // 下拉选择添加‘总部’‘全部门店’字段
              if (column.isHasAll) {
                data.data.unshift({name: '总部', id: -1})
              }
              if (column.isHasAllShop) {
                data.data.unshift({name: '全部门店', id: null})
              }
              if (column.hasAllNull) {
                data.data.unshift({name: '总部', id: ''})
              }
              this.$set(column, 'data', data.data);
            } else {
              this.$set(column, 'data', data.data);
            }
            if (column.type === this.columnType.checkbox) {
              this.setCheckBoxValue(column);
            } else if (column.type === this.columnType.radio) {
              this.setRadioValue(column);
            } else if (column.defaultIndex != undefined) {
              this.formModel[column.prop] = column.data[column.defaultIndex].value;
            }
            if (column.cache) {
              this.$utils.setDataByKey(column.url, column.data);
            }
            if (this.formModel[column.prop]) {
              this.selectChange(column, true);
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    // 给单选按钮组赋值
    // 设置了value，需要给name赋值
    setRadioValue(column) {
      let radioValue = this.formModel[column.prop.replace('Radio', '')];
      if (radioValue !== undefined && radioValue !== null && column.data) {
        let checkItem = column.data.filter((item) => {
          return item.value == radioValue || item.id == radioValue;
        });
        if (checkItem.length > 0) {
          this.$set(this.formModel, column.prop, checkItem[0].label || checkItem[0].name);
        }
      } else if (column.defaultValue) {
        let checkItem = column.data.filter((item) => {
          return (
            item.value == column.defaultValue || item.id == column.defaultValue
          );
        });
        if (checkItem.length > 0) {
          this.$set(this.formModel, column.prop, checkItem[0].label || checkItem[0].name);
        }
      } else if (column.defaultIndex) {
        let checkItem = column.data[column.defaultIndex];
        this.$set(this.formModel, column.prop, checkItem.label || checkItem.name);
        this.$set(this.formModel, column.prop.replace('radio', ''), checkItem.id || checkItem.value);
      }
    },
    setCheckBoxValue(column) {
      let checkboxValue = this.formModel[column.prop.replace('Checkbox', '')];
      if (
        checkboxValue !== undefined &&
        checkboxValue !== null &&
        checkboxValue.length > 0 &&
        column.data
      ) {
        let checkboxValue1 = [];
        checkboxValue.map(item => {
          // 纯数字类型
          if (item == parseInt(item)) {
            item = parseInt(item);
          }
          checkboxValue1.push(item);
        });
        let checkData = column.data
          .map((item) => {
            return checkboxValue1.indexOf(item.value || item.id) > -1
              ? item.name || item.label
              : null;
          })
          .filter(Boolean);
        this.formModel[column.prop] = checkData;
      } else if (column.defaultValue) {
        let checkItem = column.data.filter((item) => {
          return (
            item.value == column.defaultValue || item.id == column.defaultValue
          );
        });
        this.formModel[column.prop] = checkItem.map((item) => {
          return item.label || item.name;
        });
      } else if (column.defaultIndex) {
        this.formModel[column.prop] = [];
        this.formModel[column.prop.replace('Checkbox', '')] = [];
        column.defaultIndex.map(index => {
          let checkItem = column.data[index];
          this.formModel[column.prop].push(checkItem.label || checkItem.name);
          this.formModel[column.prop.replace('Checkbox', '')].push(checkItem.id || checkItem.value);
        });
      }
    },
    radioOneChange(column) {
      if (column.hidden || column.disabled) return;
      column.change && column.change(this.formModel, column);
    },
    // 单选按钮
    radioChange(column) {
      let radioColumn = column.data.filter(item => item.label == this.formModel[column.prop] || item.name == this.formModel[column.prop]);
      if (radioColumn.length > 0) {
        this.formModel[column.prop.replace('Radio', '')] = radioColumn[0].value || radioColumn[0].id;
      }
      if (column.hidden || column.disabled) return;
      column.change && column.change(this.formModel);
    },
    // 多选按钮组
    checkBoxChange(column) {
      this.formModel[column.prop.replace('Checkbox', '')] = [];
      column.data.map(item => {
        this.formModel[column.prop].map(checkItem => {
          if (checkItem == item.name || checkItem == item.label) {
            this.formModel[column.prop.replace('Checkbox', '')].push(item.id || item.value);
          }
        })
      })
      if (column.hidden || column.disabled) return;
      column.change && column.change(this.formModel);
    },
    valueChange(column) {
      if (column.hidden || column.disabled) return;
      column.change && column.change(this.formModel);
    },
    // 下拉框联动
    selectChange(column, fillBack) {
      if (column.childProps) { // 根据当前选项获取子集
        // 联动字段选项赋值
        let childColumn = this.formOptions.columns.filter(item => {
          return item.prop === column.childProps
        });

        if (!childColumn || !childColumn.length > 0) {
          return;
        }
        childColumn = childColumn[0];
        // 当前父类选择的数据
        let parentData = column.data.filter(dataItem => {
          return dataItem.value || dataItem.id == this.formModel[column.prop]
        });
        // 错误数据兼容
        if (parentData.length > 0) {
          childColumn.data = parentData[0].children;
        }
        this.formModel[childColumn.prop] = '';
      } else if (column.selectAssociated) { // 根据当前选项查询数据
        // 关联字段选项赋值
        let associatedcolumn = this.formOptions.columns.filter(item => {
          return item.prop === column.selectAssociated.prop
        });
        if (!associatedcolumn || !associatedcolumn.length > 0) {
          return;
        }
        if (!fillBack) {
          this.formModel[column.selectAssociated.prop] = '';
        }
        let param = {};
        param[column.associatedKey || column.prop] = this.formModel[column.prop];
        this.getSelectData(associatedcolumn[0], param, column.selectAssociated.url);
      }
      this.setNameFormId(column);
      if (column.hidden || column.disabled) return;
      column.change && column.change(this.formModel, column);
    },
    // 获取下拉时选择的名称
    setNameFormId(column) {
      if (column.multiple || !(/[\w]Id$/).test(column.prop) || !column.data || column.data.length == 0) return;

      if (this.formModel[column.prop]) {
        this.formModel[column.prop.replace(/(.*)Id/, '$1Name')] = '';
      }
      let currentItem = column.data.filter(item => {
        return item.id == this.formModel[column.prop]
      });
      if (currentItem.length > 0) {
        this.formModel[column.prop.replace(/(.*)Id/, '$1Name')] = currentItem[0].name;
      }
    },
    // 级联选择器change事件
    cascaderChange(column, selectForm) {
      Object.assign(this.formModel, selectForm);
      if (column.hidden || column.disabled) return;
      column.change(this.formModel, selectForm[column.prop]);
    },
    // 获取组件数据
    getSpecialAttributes() {
      let submitValidate = true;
      let comData = null;
      this.formOptions.columns.map(column => {
        if (column.isShow == false || column.hidden == true) return;
        // console.log(column.type,column.prop)
        switch (column.type) {
          // 文件
          case this.$utils.fileType.video.value:
          case this.$utils.fileType.voice.value:
          case this.$utils.fileType.image.value:
          case this.$utils.fileType.file.value:
            let fileList = this.$refs[column.prop][0].getFormData();
            if (fileList.length == 0 && column.specialRule && column.specialRule[0].required) {
              this.$message({ type: 'error', message: column.specialRule[0].message });
              comData = false;
            } else {
              column.callback && column.callback(this.formModel, fileList);
            }
            break;
          // 属性
          case this.columnType.attributeEditor:
            comData = this.$refs[column.prop][0].getFormData();
            if (!comData && column.specialRule && column.specialRule[0].required) {
              this.$message({ type: 'error', message: column.specialRule[0].message });
              submitValidate = false;
            }
            break;
          // 编码
          case this.columnType.code:
            console.log(this.formModel[column.prop])
            comData = this.$refs[column.prop][0].getFormData();
            if (comData) {
              this.formModel[column.prop] = comData;
            } else {
              submitValidate = false;
            }
            break;
          // 渠道号
          case this.columnType.mchntNo:
            console.log(this.formModel[column.prop])
            comData = this.$refs[column.prop][0].getFormData();
            if (comData) {
              this.formModel[column.prop] = comData;
            }
            break;
          // 验证码
          case this.columnType.verify:
            comData = this.$refs[column.prop][0].codePass;
            if (!comData) {
              this.$message({ type: 'error', message: '验证码验证未通过!' });
            }
            break;
          // 级联
          case this.columnType.casaderSelect:
            let selectForm = this.$refs[column.prop][0].getFormData();
            for (let i = 0; i < column.casaderOptions.length; i++) {
              let option = column.casaderOptions[i];
              if (option.rule && option.rule[0].required && !selectForm[option.prop]) {
                this.$message({ type: 'error', message: option.rule[0].message });
                submitValidate = false;
                break;
              }
            }
            if (submitValidate) {
              Object.assign(this.formModel, selectForm);
            }
            break;
          case this.columnType.dateTimePicker:
            if (column.before && !this.$moment(this.formModel[column.before]).isBefore(this.formModel[column.prop])) {
              this.$message({ message: '开始时间必须小于结束时间！', type: 'error' });
              submitValidate = false;
            }
            break;
          case this.columnType.checkList:
            this.$refs[column.prop][0].getFormData();
            break;
          case this.columnType.password:
            this.formModel[column.prop.replace('Plaintext', '')] = this.$utils.md5(this.formModel[column.prop]);
            break;
        }
      })
      return submitValidate;
    },
    clearSpecialAttributes() {
      this.formOptions.columns.map(column => {
        switch (column.type) {
          case this.columnType.casaderSelect:
          case this.columnType.uploadFile:
          case this.columnType.code:
          case this.columnType.attributeEditor:
            this.$refs[column.prop][0].clearData();
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/fromTemplate.js